import React from 'react'
import Vladimir from '../../assets/images/Vladimir_avatar.png'
import Gosa from '../../assets/images/Gosa_avatar.png'
import Timofey from '../../assets/images/Timofey_avatar.png'
import Alex from '../../assets/images/Alex_avatar.png'

const Background = () => {
  return (
    <div className="background">
      <span className="bg-image Vladimir">
        <img src={Vladimir} alt="Vladimir avatar" />
      </span>
      <span className="bg-image Gosa">
        <img src={Gosa} alt="Gosa avatar" />
      </span>
      <span className="bg-image Timofey">
        <img src={Timofey} alt="Timofey avatar" />
      </span>
      <span className="bg-image Alex">
        <img src={Alex} alt="Alex avatar" />
      </span>
    </div>
  )
}

export default Background